// BotMessage.js
import React from "react";
import "./ChatbotWidget.css";

const BotMessage = ({ message }) => {
  return (
    <div className="react-chatbot-kit-chat-bot-message">
      <span
        style={{ color: "white" }}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </div>
  );
};

export default BotMessage;